module.exports = __webpack_public_path__ + "img/20191022164034708.a5f0d431.jpg";